export class EmailAttachmentConfig {
	Email: string = "";
	Attachments: string[] = []; // ["pdf", "ubl", "xml"]

	public constructor(data?: any) {
		if (!data) return;
		this.Email = data.Email || "";
		this.Attachments = data.Attachments || [];
	}

	public getJSON() {
		return {
			Email: this.Email,
			Attachments: this.Attachments
		};
	}
}
